var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[(_vm.avatarImageSource)?_c('div',{staticClass:"avatar__placeholder",style:({ 'background-image': ("url('" + _vm.avatarImageSource + "')") })}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }